import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createCustomerForPartner,
  CreateCustomerForPartnerPayload,
  PartnerCustomerListItem,
} from '../../api/queries';
import { PARTNER_CUSTOMERS_QUERY_KEY } from '../queries/useGetPartnerCustomersQuery';

export const useCreateCustomerForPartnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCustomerForPartner,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PARTNER_CUSTOMERS_QUERY_KEY });
    },
  });
};
